<template>
    <div class="score">
        <el-dialog v-drag :visible.sync="dialogVisible" width="60%">
            <div class="mt bold" slot="title">{{ $t('AI评分') }}</div>

            <template v-if="source.type == 1">
                <div style="background-color: #f5f5f5;word-break: keep-all;" class="padding-s">
                    <div v-for="(value, index) in info0.result.segments" :key="value.segment_index"
                        class="margin-b padding-s">
                        <div class="bold">Segment {{ Number(value.segment_index) + 1 }}</div>
                        <div class="margin-t flex flex-v-center"><span class="bold">{{ $t('我的录音') }}:</span>
                            <wave-player v-if="JSON.parse(info0.content)[index] && JSON.parse(info0.content)[index].url"
                                class="margin-x" :src="$host + JSON.parse(info0.content)[index].url"></wave-player>
                            <span v-else class="st margin-l">{{ $t('未作答') }}</span>
                        </div>

                        <div class="margin-t"><span class="bold">{{ $t('音频原文') }}:</span> {{
                            source.words_en.split('\n')[value.segment_index]
                            }}</div>
                        <div class="margin-t"><span class="bold">{{ $t('参考翻译') }}:</span>&nbsp; {{
                            value.reference_translation
                        }}</div>
                        <div class="margin-t" v-if="value.my_translation"><span class="bold">{{ $t('我的翻译') }}:</span>
                            &nbsp;{{
                                value.my_translation
                            }}
                        </div>
                        <div class="margin-t"><span class="bold">{{ $t('错误分析') }}:</span>&nbsp; {{ value.error_analysis
                        }}
                        </div>
                    </div>
                    <el-divider></el-divider>
                    <div class="bold margin-t">
                        {{ $t('得分') }}： <span class="color-primary">{{ info0.result.final_score }}</span> / 45
                    </div>

                    <div class="bold margin-t">
                        {{ $t('总结') }}： {{ info0.result.summary }}
                    </div>
                </div>
            </template>
            <template v-else>
                <el-table :border="true" :data="tableData" style="width: 100%">
                    <el-table-column prop="item1" :label="$t('单项')" width="300px">
                        <template slot-scope="scope">
                            <div>{{ $t(scope.row.item1) }}
                                <i slot="reference" @click="showDialog(scope.row.item1)"
                                    class="el-icon-question lt color-green pointer"></i>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="item2" :label="$t('得分')">
                        <template slot-scope="scope">
                            <div class="st bold">{{ scope.row.item2 }}</div>
                            <el-progress v-if="info0.source.tag != 'ASQ'" status="success" :percentage="scope.row.item4"
                                :show-text="false"></el-progress>
                        </template>
                    </el-table-column>
                </el-table>

                <div class="margin-t flex flex-v-center" style="position: relative;">
                    <div class="mt bold" v-if="source.tag == 'ASQ'">{{ $t('评分') }}：<span class="color-primary">{{
                        info0.score
                            }}</span> /
                        1</div>
                    <div class="mt bold" v-else-if="source.tag == 'SWT'">{{ $t('评分')
                        }}：<span class="color-primary">{{
                            info0.score
                            }}</span>
                        /
                        9</div>

                         <div class="mt bold" v-else-if=" source.tag == 'SWT-Core'">{{ $t('评分')
                        }}：<span class="color-primary">{{
                            info0.score
                            }}</span>
                        /
                        8</div>
                    <div class="mt bold" v-else-if="source.tag == 'WE'">{{ $t('评分') }}：<span class="color-primary">{{
                        info0.score
                            }}</span>
                        /
                        26</div>
                    <div class="mt bold" v-else-if="source.tag == 'WE-Core'">{{ $t('评分') }}：<span
                            class="color-primary">{{
                                info0.score
                            }}</span>
                        /
                        15</div>
                    <div class="mt bold" v-else-if="source.tag == 'SST'">{{ $t('评分')
                        }}：<span class="color-primary">{{
                            info0.score
                            }}</span>
                        /12
                    </div>

                    <div class="mt bold" v-else-if="source.tag == 'SST-Core'">{{ $t('评分')
                        }}：<span class="color-primary">{{
                            info0.score
                            }}</span>
                        /10
                    </div>
                    <div class="mt bold" v-else>{{ $t('评分') }}：<span class="color-primary">{{ format_number(info0.score
                        *
                        0.9)
                            }}</span> / 90
                    </div>
                    <wave-player v-if="info0.content.indexOf('.wav') != -1" class="margin-x"
                        :src="$host + info0.content"></wave-player>
                    <!-- <div class="st margin-l">{{ info0.result_time }}</div> -->

                    <div style="position: absolute;right:20px;top:0;" class="mt bold color-primary"
                        v-if="['SWT', 'SWT-Core', 'WE', 'WE-Core', 'SST', 'SST-Core'].indexOf(source.tag) != -1">{{ $t('字数')
                        }}：{{
                            wordCount(info0.content)
                        }}
                    </div>
                </div>
                <div class="margin-lt"></div>
                <el-divider>
                    <div v-if="info0.content.indexOf('.wav') != -1" class="flex flex-v-center">
                        <h3>{{ $t('AI语音识别') }}</h3>
                    </div>
                </el-divider>

                <div v-if="info0.source.tag == 'SWT' || info0.source.tag == 'SWT-Core' || info0.source.tag == 'WE' || info0.source.tag == 'WE-Core' || info0.source.tag == 'SST' || info0.source.tag == 'SST-Core'"
                    class="margin-t">
                    <div class="st bold margin-bs">
                        {{ $t('AI评测结果') }}：
                    </div>

                    <div v-for="(row, i) in info.words.replace(/\./g, '. ').split('\n')" :key="i">

                        <div v-if="row">
                            <span :class="(word == ',' || word == '.' || word == '?') ? 'word0' : 'word0'" class="word"
                                v-for="(word, index) in row.replace(/\s+/g, ' ').split(' ')" :key="index">
                                <el-popover class="word" v-if="word.indexOf('^') != -1" placement="top-start" title=""
                                    trigger="hover" :content="word.split('^')[1].replace(/】\w/g, '】')">
                                    <span class="pointer"
                                        style="color:red;text-decoration: underline;word-break: keep-all;"
                                        slot="reference">{{
                                            word.split('^')[0] }}</span>
                                </el-popover>
                                <span v-else
                                    :style="{ color: (word == row.replace(/\s+/g, ' ').split(' ')[index - 1] || word == row.replace(/\s+/g, ' ').split(' ')[index + 1]) ? 'red' : '' }"
                                    style="word-break: keep-all;" v-word> {{ word }}</span>
                            </span>
                        </div>
                        <div v-else style="height: 10px;"></div>
                    </div>
                </div>
                <div v-else-if="info0.source.tag == 'ASQ'" class="margin-t word">
                    {{ info }}
                </div>
                <div v-else class="margin-t">
                    <div v-if="['RA', 'RS'].indexOf(info0.source.tag) == -1" class="flex flex-h-end">
                        <div class="flex flex-v-center margin-x" v-for="(item, index) in items.slice(1)" :key="index">
                            <div class="dot" :class="'v' + (index + 1)"></div>
                            <div>{{ item }}</div>
                        </div>
                        <div class="flex flex-v-center margin-x">
                            <div>/ {{ $t('停顿') }}</div>
                        </div>
                    </div>


                    <div v-else class="flex flex-h-end">
                        <div class="flex flex-v-center margin-x" v-for="(item, index) in items" :key="index">
                            <div class="dot" :class="'v' + index"></div>
                            <div>{{ $t(item) }}</div>
                        </div>
                        <div class="flex flex-v-center margin-x">
                            <div>/ {{ $t('停顿') }}</div>
                        </div>
                    </div>

                    <div class="flex flex-wrap margin-t">
                        <el-popover width="400" @show="showDetail(item.word)" placement="top" trigger="click"
                            v-for="(item, index) in info.words" :key="index">
                            <div class="st1">{{ item.pronunciation > 80 ? $t("发音正确，请继续保持") : item.pronunciation > 60 ?
                                $t("发音有点问题，稍作改变会更完美")
                                : item.pronunciation > 0 ? $t("发音糟糕，请听正确发音并纠正") : $t("没有读这个单词") }}</div>
                            <div class="line margin-ts"></div>
                            <h3 class="margin-ts">{{ item.word }}</h3>
                            <div class="st"><span style="margin-right: 10px;">{{ $t("你的发音") }}:</span>[<span
                                    v-for="(ph, index1) in item.phonemes"
                                    :class="{ 'v0': ph.pronunciation < 60, 'v1': ph.pronunciation >= 60 && ph.pronunciation <= 80, 'v2': ph.pronunciation >= 80 }"
                                    :key="index1">{{ ph.phoneme }}</span>]
                            </div>
                            <div v-loading="loading1">
                                <div class="st1 flex flex-v-center">[UK]<span style="margin:0 10px;">[{{
                                    wordInfo.phonetic[0]
                                        }}]</span>
                                    <el-image @click="play(1, item.word)" class="margin-x"
                                        style="width: 24px; height: 24px;cursor: pointer;"
                                        src="/web/image/playing.png"></el-image>
                                </div>
                                <div class="st1 flex flex-v-center">[US]<span style="margin:0 10px;">[{{
                                    wordInfo.phonetic[1] }}]</span>
                                    <el-image @click="play(2, item.word)" class="margin-x"
                                        style="width: 24px; height: 24px;cursor: pointer;"
                                        src="/web/image/playing.png"></el-image>
                                </div>
                                <div class="st1">
                                    <div v-for="(row, index) in $t1(wordInfo, 'explanation').split('\n')" :key="index">
                                        {{ row }}
                                    </div>
                                </div>
                            </div>
                            <span slot="reference" class="word" :class="getClass(item)">{{ item.word }}
                                <span style="color:#333"
                                    v-if="index < info.words.length - 1 && (info.words[index + 1].start - info.words[index].end > 0.4)">//</span>
                                <span style="color:#333"
                                    v-else-if="index < info.words.length - 1 && (info.words[index + 1].start - info.words[index].end > 0.1)">/</span>

                            </span>
                        </el-popover>
                    </div>
                    <div class="margin-t center st1">{{ $t('点击彩色单词可查看解析') }}</div>
                </div>
            </template>
            <div slot="footer" class="center">
                <el-button type="primary" size="small" @click="dialogVisible = false">{{ $t('关闭') }}</el-button>
            </div>
        </el-dialog>

        <tip-dialog ref="tipDialog"></tip-dialog>
        <audio ref="audio"></audio>
    </div>
</template>

<script>
import tipDialog from '../components/TipDialog.vue';
import WavePlayer from '../components/WavePlayer.vue';

import drag from "./drag";

export default {
    name: "scoreDialog",
    components: {
        WavePlayer, tipDialog
    },
    directives: {
        drag
    },
    props: {
        mock: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            dialogVisible: false,
            info: {},
            info0: { source: {}, content: "" },
            tableData: [],
            items: ['漏读', '差', '良', '优'],
            wordInfo: { phonetic: [], explanation: "" },
            loading1: false,
            source: {},
            centerDialogVisible: false,
            tips: [],
        };
    },

    created() {
    },
    methods: {

        wordCount(content) {
            if (content) {
                content = content.trim().replace(/[^-\w]+/g, ' ');
                if (content.trim()) {
                    return content.trim().split(" ").length;
                } else {
                    return 0;
                }
            } else {
                return 0;
            }
        },
        format_number(val) {
            return parseFloat(val).toFixed(0);
        },
        play(type, word) {
            this.src = this.$host + "/api/word/audio/" + word + "/" + type
            this.$refs.audio.src = this.src;
            this.$refs.audio.play();
        },

        getClass(item) {
            if (item.pronunciation == 0) {
                if (['RA', 'RS'].indexOf(this.info0.source.tag) == -1) {
                    return "v1";
                } else {
                    return "v0";
                }
            } else if (item.pronunciation < 60) {
                return "v1";
            } else if (item.pronunciation < 85) {
                return "v2";
            } else if (item.pronunciation <= 100) {
                return "v3";
            }
        },

        showDialog(title) {
            this.$refs.tipDialog.show(this.source.tag, title)
        },

        showDetail(word) {
            let info = this.$store.getters.getWord(word);
            if (info) {
                this.wordInfo = info;
            } else {
                this.loading1 = true;
                this.$http.post("/api/word/info", { word: word }).then((info) => {
                    this.wordInfo = info;
                    this.$store.commit("addWord", info);
                    this.loading1 = false;
                });
            }
        },


        show(id) {
            this.tableData = [];
            if (this.mock) {
                this.$http.post("/api/mock/record/item/info", { id: id }).then((info) => {
                    this.showInfo(info);
                })
            } else {
                this.$http.post("/api/record/info", { id: id }).then((info) => {
                    this.showInfo(info);
                })
            }

        },


        showInfo(info) {
            this.tableData = [];
            this.dialogVisible = true;
            this.info0 = info;

            this.info = info.result;

            this.source = info.source;


            if (this.source.type == 0) {

                this.tableData = [];
                if (this.source.tag == "SWT" || this.source.tag == "SWT-Core") {
                    const content = this.source.tag == "SWT-Core" ? 2 : 4;
                    this.tableData.push({
                        item1: "Content",
                        item2: this.info.content + "/" + content,
                        item4: parseInt(this.info.content / content * 100)
                    })

                    const form = this.source.tag == "SWT-Core" ? 2 : 1;

                    this.tableData.push({
                        item1: "Form",
                        item2: this.info.form + "/" + form,
                        item4: parseInt(this.info.form / form * 100)
                    })
                    this.tableData.push({
                        item1: "Grammar",
                        item2: this.info.grammar + "/2",
                        item4: parseInt(this.info.grammar / 2 * 100)
                    })

                    this.tableData.push({
                        item1: "Vocabulary",
                        item2: this.info.vocabulary + "/2",
                        item4: parseInt(this.info.vocabulary / 2 * 100)
                    })
                } else if (this.source.tag == "WE") {
                    this.tableData.push({
                        item1: "Content",
                        item2: this.info.content + "/6",
                        item4: parseInt(this.info.content / 6 * 100)
                    })
                    this.tableData.push({
                        item1: "Form",
                        item2: this.info.form + "/2",
                        item4: parseInt(this.info.form / 2 * 100)
                    })

                    this.tableData.push({
                        item1: "Development, structure and coherence",
                        item2: this.info.structure + "/6",
                        item4: parseInt(this.info.structure / 6 * 100)
                    })

                    this.tableData.push({
                        item1: "Grammar",
                        item2: this.info.grammar + "/2",
                        item4: parseInt(this.info.grammar / 2 * 100)
                    })


                    this.tableData.push({
                        item1: "General linguistic range",
                        item2: this.info.linguisticRange + "/6",
                        item4: parseInt(this.info.linguisticRange / 6 * 100)
                    })
                    this.tableData.push({
                        item1: "Vocabulary range",
                        item2: this.info.vocabularyRange + "/2",
                        item4: parseInt(this.info.vocabularyRange / 2 * 100)
                    })

                    this.tableData.push({
                        item1: "Spelling",
                        item2: this.info.spelling + "/2",
                        item4: parseInt(this.info.spelling / 2 * 100)
                    })
                }else if (this.source.tag == "WE-Core") {
                    this.tableData.push({
                        item1: "Content",
                        item2: this.info.content + "/3",
                        item4: parseInt(this.info.content / 3 * 100)
                    })
                    this.tableData.push({
                        item1: "Email Conventions",
                        item2: this.info.conventions + "/2",
                        item4: parseInt(this.info.conventions / 2 * 100)
                    })

                    this.tableData.push({
                        item1: "Form",
                        item2: this.info.form + "/2",
                        item4: parseInt(this.info.form / 2 * 100)
                    })

                    this.tableData.push({
                        item1: "Organization",
                        item2: this.info.organization + "/2",
                        item4: parseInt(this.info.organization / 2 * 100)
                    })


                    this.tableData.push({
                        item1: "Vocabulary",
                        item2: this.info.vocabulary + "/2",
                        item4: parseInt(this.info.vocabulary / 2 * 100)
                    })
                    this.tableData.push({
                        item1: "Grammar",
                        item2: this.info.grammar + "/2",
                        item4: parseInt(this.info.grammar / 2 * 100)
                    })

                    this.tableData.push({
                        item1: "Spelling",
                        item2: this.info.spelling + "/2",
                        item4: parseInt(this.info.spelling / 2 * 100)
                    })
                } else if (this.source.tag == "SST" || this.source.tag == "SST-Core") {
                    const content = this.source.tag == "SST-Core" ? 2 : 4;
                    this.tableData.push({
                        item1: "Content",
                        item2: this.info.content + "/" + content,
                        item4: parseInt(this.info.content / content * 100)
                    })

                    const form = this.source.tag == "SST-Core" ? 2 : 1;
                    this.tableData.push({
                        item1: "Form",
                        item2: this.info.form + "/" + form,
                        item4: parseInt(this.info.form / form * 100)
                    })

                    this.tableData.push({
                        item1: "Grammar",
                        item2: this.info.grammar + "/2",
                        item4: parseInt(this.info.grammar / 2 * 100)
                    })

                    this.tableData.push({
                        item1: "Vocabulary",
                        item2: this.info.vocabulary + "/2",
                        item4: parseInt(this.info.vocabulary / 2 * 100)
                    })

                    this.tableData.push({
                        item1: "Spelling",
                        item2: this.info.spelling + "/2",
                        item4: parseInt(this.info.spelling / 2 * 100)
                    })
                } else if (this.source.tag == "ASQ") {
                    this.tableData.push({
                        item1: "词汇",
                        item2: info.score + "/1",
                    })
                } else {

                    this.tableData.push({
                        item1: this.source.tag == "RTS-Core" ? "准确性" : "内容分",
                        item2: (parseInt(info.result.integrity * 0.9) < 10 ? 10 : parseInt(info.result.integrity * 0.9)) + "/90",
                        item4: 0
                    })

                    this.tableData.push({
                        item1: "发音",
                        item2: (parseInt(info.result.pronunciation * 0.9) < 10 ? 10 : parseInt(info.result.pronunciation * 0.9)) + "/90",
                        item4: 0
                    })

                    this.tableData.push({
                        item1: "流利度",
                        item2: (parseInt(info.result.fluency * 0.9) < 10 ? 10 : parseInt(info.result.fluency * 0.9)) + "/90",
                        item4: 0
                    })

                    console.log(this.tableData)
                    setTimeout(() => {
                        this.tableData[0].item4 = info.result.integrity * 0.9 <= 10 ? (10 / 90 * 100) : parseInt(info.result.integrity)

                        this.tableData[1].item4 = info.result.pronunciation * 0.9 <= 10 ? (10 / 90 * 100) : parseInt(info.result.pronunciation)

                        this.tableData[2].item4 = info.result.fluency * 0.9 <= 10 ? (10 / 90 * 100) : parseInt(info.result.fluency);

                    }, 800);
                }
            }
        },
    },
};
</script>
<style scoped>
.word {
    margin: 2.5px;
    font-size: 18px;
}

.word.word0 {
    margin: 0;
    padding: 0;
}

.word.word-dot {
    margin: 0;
    padding: 0;
    margin-left: -10px;
    cursor: auto;
}

.word.word-dot:hover {
    background-color: transparent;
}


.word.v0 {
    color: #909399;
}

.word.v1 {
    color: #F56C6C;
}

.word.v2 {
    color: #E6A23C;
}

.word.v3 {
    color: #67C23A;
}


.v0 {
    color: red;
}

.v1 {
    color: yellow;
}

.dot {
    margin-top: 5px;
    height: 14px;
    width: 14px;
    border-radius: 50%;
}

.dot.v0 {
    background-color: #909399;
}

.dot.v1 {
    background-color: #F56C6C;
}

.dot.v2 {
    background-color: #E6A23C;
}

.score>>>.el-progress.is-success .el-progress-bar__inner {
    background-color: #e6a13c;
}

.dot.v3 {
    background-color: #67C23A;
}
</style>